<!-- Please don’t change these IDs because those are for automated testing: mapNameInput, accessLevelSelectBox, localeIdsSelectBox, mapAddressInput, mapStartLocationInput, mapEndLocationInput, mapSaveBtn, mapCancelBtn -->
<form [formGroup]="mapForm" (ngSubmit)="submitForm()">
  <div class="edit__form">
    <div class="row input__row">
      <div class="col-sm-7">
        <div class="input-field">
          <label>{{ translations.MAP.TITLE | translate}}</label>
          <input id="mapNameInput" type="text" [placeholder]="getTranslation(translations.MAP.TITLE)" formControlName="mapName" />
          @if (mapName.invalid && isSubmitted) {
            <div class="custom_error">
              <!-- {{getValidationErrors(mapName, getTranslation(translations.MAP.TITLE), 25, 2)}} -->
              {{getValidationErrors(mapName, getTranslation(translations.MAP.TITLE))}}
            </div>
          }
        </div>
      </div>
    </div>
    <div class="row input__row">
      <div class="col-sm-7">
        <div class="input-field">
          <label class="required__text">{{ translations.MAP.SELECT_ACCES_LEVEL | translate}}</label>
          <ng-select id="accessLevelSelectBox" [clearable]='isClearable' [hideSelected]='true' [searchable]="false" formControlName="accessLevel">
            <ng-option hidden value="" disabled selected>{{ translations.MAP.SELECT_ACCES_LEVEL | translate}}</ng-option>
            @for (authType of users | keyvalue; track authType) {
              @if (authType.value.isVisibleInList) {
                <ng-option value="{{authType.value.role}}">
                  {{ translations.GLOBAL.KEYS[authType.value.name] | translate}}
                </ng-option>
              }
            }
          </ng-select>
          @if (accessLevel.invalid && isSubmitted) {
            <div class="custom_error">
              @if (accessLevel.errors.required) {
                <div>
                  {{
                  translations.GLOBAL.VALIDATION_MESSAGES.REQUIRED |
                  translate : { "name": translations.MAP.ACCES_LEVEL | translate }
                  }}
                </div>
              }
            </div>
          }
        </div>
      </div>
    </div>
    <div class="row input__row">
      <div class="col-sm-7">
        <div class="input-field">
          <label>{{ translations.MAP.IS_MAP_PUBLIC_OR_PRIVATE | translate}}</label>
          <div class="yesno__type__radio">
            <div class="yesno__radio__box">
              <input type="radio" formControlName="isPrivate" name="isPrivate" [value]="true" id="Private" class="css-checkbox yesa">
              <label for="Private" class="css-label radGroup2">
                {{ translations.GLOBAL.KEYS.PRIVATE | translate}}
              </label>
            </div>
            <div class="yesno__radio__box">
              <input type="radio" formControlName="isPrivate" name="isPrivate" [value]="false" id="Public" class="css-checkbox noa">
              <label for="Public" class="css-label radGroup2">
                {{ translations.GLOBAL.KEYS.PUBLIC | translate}}
              </label>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row input__row">
      <div class="col-sm-7">
        <div class="input-field">
          <label>
            {{translations.GLOBAL.KEYS.SELECT_LOCALE | translate}}
          </label>
          <app-locale-search-box
            class="authbox-select"
            [localeFormValue]="localeIds.value"
            [setLocaleOption]="localeListBindValueField._id"
            [showLocaleOption]="localeListBindLabelField.localepath"
            [setMultiple]="true"
            (localeSelected)="selectLocales($event)"
            (localeFormTouched)="localeIds.markAsTouched()">
          </app-locale-search-box>
          @if (localeIds.errors && isSubmitted) {
            <div class="custom_error">
              <div>
                {{
                translations.GLOBAL.VALIDATION_MESSAGES.REQUIRED |
                translate : { "name": translations.GLOBAL.KEYS.LOCALE | translate }
                }}
              </div>
            </div>
          }
        </div>
      </div>
    </div>
    <div class="row input__row">
      <div class="col-sm-7">
        <div class="input-field">
          <label>
            {{ translations.GLOBAL.KEYS.STATUS | translate}}
          </label>
          <div class="yesno__type__radio">
            <div class="yesno__radio__box">
              <input type="radio" id="active" class="css-checkbox yesa" name="status"
                formControlName="status" [value]="statusType.ACTIVE">
              <label for="active" class="css-label radGroup2">
                {{ translations.GLOBAL.KEYS.ACTIVE | translate}}
              </label>
            </div>
            <div class="yesno__radio__box">
              <input type="radio" id="inactive" class="css-checkbox yesa" name="status"
                formControlName="status" [value]="statusType.INACTIVE">
              <label for="inactive" class="css-label radGroup2">
                {{ translations.GLOBAL.KEYS.INACTIVE | translate}}
              </label>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row input__row">
      <div class="col-sm-10">
        <div class="input-field">
          <label>
            {{ translations.MAP.DRAW_ROOT_MAP | translate}}
          </label>
          <div class="yesno__type__radio">
            @for ( mapType of mapTypeDetails | keyvalue; track  mapType) {
              <div class="yesno__radio__box">
                <input type="radio" formControlName="mapType" name="mapType"
                  [value]="mapType.value.Value" [id]="mapType.value.Label"
                  class="css-checkbox yesa">
                <label [for]="mapType.value.Label" class="css-label radGroup2">
                  {{ translations.GLOBAL.KEYS[mapType.value.Label] | translate}}
                </label>
              </div>
            }
          </div>
        </div>
        <div class="open_map_fields">
          @if (isManualMapSelected) {
            <div id="manualmap" class="manual_map_field">
              <div class="row input__row">
                <div class="col-sm-10">
                  <div class="input-field">
                    <input type="googleInputLocation" [addressFormControl]="formattedAddress" id="mapAddressInput"
                      formControlName="formattedAddress"
                      [placeholder]="getTranslation(translations.GLOBAL.KEYS.ADDRESS_PLACEHOLDER)"
                      [shouldIgnoreSettingFormGroupValue]="true"
                      (locFormGroupDataChanged)="setLatLangForMap($event, formattedAddress)"/>
                      @if (formattedAddress.invalid && isSubmitted) {
                        <div class="custom_error">
                          @if (formattedAddress.errors.isValidAddressFromList && !formattedAddress.errors.required) {
                            <div>
                              {{
                              translations.GLOBAL.VALIDATION_MESSAGES.CHOOSE_ADDRESS_FROM_DROPDOWN |
                              translate : { "name": translations.GLOBAL.KEYS.ADDRESS | translate }
                              }}
                            </div>
                          }
                          @if (formattedAddress.errors.required) {
                            <div>
                              {{
                              translations.GLOBAL.VALIDATION_MESSAGES.REQUIRED |
                              translate : { "name": translations.GLOBAL.KEYS.ADDRESS | translate }
                              }}
                            </div>
                          }
                        </div>
                      }
                    </div>
                  </div>
                </div>
              </div>
            }
            @if (isAutoMapSelected) {
              <div id="automap" class="auto_map_field">
                <div class="row input__row input__row__no__margin" formGroupName="auto">
                  <div class="col-sm-5">
                    <div class="input-field">
                      <input type="googleInputLocation" [shouldIgnoreSettingFormGroupValue]="true" id="mapStartLocationInput"
                        formControlName="startLocation"
                        [addressFormControl]="startLocation"
                        [placeholder]="getTranslation(translations.MAP.START_LOCATION)"
                        (locFormGroupDataChanged)="setLatLangForMap($event, startLocation, locationType.START)">
                        @if (startLocation.errors && isSubmitted) {
                          <div class="custom_error">
                            @if (startLocation.errors.required) {
                              <div>
                                {{
                                translations.GLOBAL.VALIDATION_MESSAGES.REQUIRED |
                                translate :
                                { 'name': translations.MAP.START_LOCATION | translate}
                                }}
                              </div>
                            }
                            @if (startLocation.errors.isValidAddressFromList && !startLocation.errors.required) {
                              <div>
                                {{
                                translations.GLOBAL.VALIDATION_MESSAGES.CHOOSE_ADDRESS_FROM_DROPDOWN |
                                translate : { "name": translations.MAP.START_LOCATION | translate }
                                }}
                              </div>
                            }
                          </div>
                        }
                      </div>
                    </div>
                    <div class="col-sm-5">
                      <div class="input-field">
                        <input type="googleInputLocation" [shouldIgnoreSettingFormGroupValue]="true" id="mapEndLocationInput"
                          formControlName="endLocation"
                          [addressFormControl]="endLocation"
                          [placeholder]="getTranslation(translations.MAP.END_LOCATION)"
                          (locFormGroupDataChanged)="setLatLangForMap($event, endLocation, locationType.END)">
                        @if (endLocation.errors && isSubmitted) {
                          <div class="custom_error">
                            @if (endLocation.errors.required) {
                              <div>
                                {{
                                translations.GLOBAL.VALIDATION_MESSAGES.REQUIRED |
                                translate :
                                { 'name': translations.MAP.END_LOCATION | translate}
                                }}
                              </div>
                            }
                            @if (endLocation.errors.isValidAddressFromList && !endLocation.errors.required) {
                              <div>
                                {{
                                translations.GLOBAL.VALIDATION_MESSAGES.CHOOSE_ADDRESS_FROM_DROPDOWN |
                                translate : { "name": translations.MAP.END_LOCATION | translate }
                                }}
                              </div>
                            }
                          </div>
                        }
                      </div>
                    </div>
                  </div>
                </div>
              }
            </div>
          </div>
        </div>
        <div class="row input__row">
          <div class="col-sm-12">
            <div class="input-field">
              <div class="full__map border-5 challenges-maps-full">
                <app-custom-route-map-preview #mapView
                  [destination]="destination"
                  [mapType]="selectedMapType.value"
                  [initialMarkersValue]="initialMarkers"
                  [origin]="origin"
                  [token]="token"
                  [zoom]="zoom"
                  (allMarkersRemoved)="handleAllMarkersRemoved()"
                  (markersUpdated)="saveMarkers($event)"
                  (noRouteFound)="showErrorForNoRouteFound()">
                </app-custom-route-map-preview>
                @if (markers.errors && isSubmitted) {
                  <div class="custom_error">
                    @if (markers.errors.nonEmptyArrayRequired) {
                      <div>
                        {{
                        translations.MAP.PLEASE_MARK_ATLEAST_2_LOCATIONS | translate
                        }}
                      </div>
                    }
                  </div>
                }
              </div>
            </div>
          </div>
        </div>
        <div class="input__button__box">
          <button class="orange-btn_outline" id="mapSaveBtn" [disabled]="!hasFormChanges">
            {{ translations.GLOBAL.KEYS.SAVE | translate}}
          </button>
          <button type="button" class="gray-btn_outline" id="mapCancelBtn" (click)="closeMapForm()">
            {{ translations.GLOBAL.KEYS.CANCEL | translate}}
          </button>
        </div>
      </div>
    </form>